import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-data.component';

let analyticsModule = angular.module('app.containers.analytics-data', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsData', {
      url: '/analytics-data',
      template: '<analytics-data></analytics-data>'
    });
})

.component('analyticsData', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-data/analytics-data.js
 **/